import DefaultDoubleSidePage from "@Front/Components/LayoutTemplates/DefaultDoubleSidePage";
import classes from "./classes.module.scss";
import backgroundImage from "@Assets/images/background_refonte.svg";
import { useRouter } from "next/router";
import { useLoginController, LoginStep } from "./hooks/useLoginController";
import { ErrorAlert } from "@Front/Components/DesignSystem/ErrorAlert";
import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";
import { useLoginErrorParamToaster } from "./hooks/useLoginErrorParamToaster";
import { LoginStepPanels } from "./components/LoginStepPanels";

export { LoginStep };

export default function Login(): React.JSX.Element {
	const router = useRouter();
	const controller = useLoginController();
	const loginErrorTitle = useSiteTextContent("login.errorTitle");
	const loginErrorMessage = useLoginErrorParamToaster(router, loginErrorTitle);

	return (
		<DefaultDoubleSidePage title={"Login"} image={backgroundImage}>
			<div className={classes["root"]}>
				{loginErrorMessage && (
					<div role="alert" aria-live="polite" className={classes["error-banner"]}>
						<ErrorAlert error={loginErrorMessage} title={loginErrorTitle} variant="default" />
					</div>
				)}
				<LoginStepPanels controller={controller} />
			</div>
		</DefaultDoubleSidePage>
	);
}
